import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { Button } from 'shared/ui/button'

import { InsuranceInsuredPerson } from '../../model/types'

import { ParticipantItem } from './ui/participant-item'

import s from './styles.module.scss'

interface InsuranceParticipantsDialogProps {
  participants: InsuranceInsuredPerson[]
  onClose: () => void
}

export const InsuranceParticipantsDialog: FC<
  InsuranceParticipantsDialogProps
> = ({ participants, onClose }) => {
  const { t } = useTranslation()

  return (
    <div className={s.dialog}>
      <h2 className={clsx(s.title, 'bold-20')}>
        {t('insurance.vzr.participants_details.title', {
          count: participants.length,
        })}
      </h2>
      <ul className={s.list}>
        {participants.map((participant, index) => (
          <ParticipantItem
            key={`${participant.passportNumber}-${index}`}
            number={index + 1}
            participant={participant}
          />
        ))}
      </ul>
      <Button
        type="button"
        className={clsx(s.button, 'bold-17')}
        onClick={onClose}
      >
        {t('insurance.vzr.participants_details.close')}
      </Button>
    </div>
  )
}
